import { IApiService } from './IApiService';
import { ApiService } from './ApiService';
import apiResponse, { ApiResponse } from './ApiResponse';

/** A published questionnaire an admin can assign in the cohort dialog. */
export interface QuestionnaireFormOption {
  id: number;
  code: string;
  name: string;
}

/** A schedule an admin can ask an assigned questionnaire on. */
export interface QuestionnaireScheduleOption {
  id: number;
  code: string;
  name: string;
}

/** One questionnaire a cohort asks, and the schedule it asks it on. */
export interface QuestionnaireAssignment {
  formId: number;
  scheduleId: number;
}

export class QuestionnaireAssignmentStore {
  constructor(private readonly api: IApiService = new ApiService()) {}

  public async GetForms(): Promise<ApiResponse<QuestionnaireFormOption[]>> {
    try {
      const response = await this.api.get('/QuestionnaireForm');
      return apiResponse.Success<QuestionnaireFormOption[]>(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async GetSchedules(): Promise<ApiResponse<QuestionnaireScheduleOption[]>> {
    try {
      const response = await this.api.get('/QuestionnaireSchedule');
      return apiResponse.Success<QuestionnaireScheduleOption[]>(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async GetCohortAssignments(cohortId: number): Promise<ApiResponse<QuestionnaireAssignment[]>> {
    try {
      const response = await this.api.get(`/Cohort/${cohortId}/questionnaires`);
      return apiResponse.Success<QuestionnaireAssignment[]>(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async SyncCohortAssignments(cohortId: number, assignments: QuestionnaireAssignment[]): Promise<ApiResponse> {
    try {
      const response = await this.api.put(`/Cohort/${cohortId}/questionnaires`, { assignments: assignments });
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
